import React from 'react';
import { ThemeProvider, CssBaseline, Container } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme';
import HomePage from './pages/HomePage';
import InfoPage from './pages/InfoPage';
import ServicesPage from './pages/ServicesPage';
import WebDesignPage from './pages/WebDesignPage';
import DocumentsTranslationPage from './pages/DocumentsTranslationPage';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactPage from './pages/ContactPage';
import AboutCompanyPage from './pages/AboutCompanyPage';
import ServicesOverviewPage from './pages/ServicesOverviewPage';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />

        <Container maxWidth={false} disableGutters>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/webdesign" element={<WebDesignPage />} />
            <Route path="/legal" element={<DocumentsTranslationPage />} />
            <Route path="/info" element={<InfoPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about-company" element={<AboutCompanyPage />} />
            <Route path="/services-overview" element={<ServicesOverviewPage />} />

          </Routes>
        </Container>

        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;
